export function sendResponse(octokitResponse) {
    return new Response(octokitResponse.text, {
        status: octokitResponse.status,
        headers: octokitResponse.headers,
    });
}
